import api from "../../../lib/api";

export const getSpinnerDataApi = () => {
  return api.get("/common/spinner");
};

export const getSiteThemeConfigApi = () => {
  return api.get("/common/site-config");
};

export const getAwsSignedUrl = (data: { path: string }) => {
  return api.post("common/signed-url", data);
};
